import i18n from './index'

/**
 * Traduce il nome di una coltura (crop.name, vocabolario fisso da DB — vedi
 * docs/todo/I18N_TODO.md) rispettando la lingua corrente. Se il nome non è
 * presente nel vocabolario cropVocab (né lingua corrente né fallback 'it'),
 * ritorna il valore originale così com'è arrivato dal DB.
 *
 * Accesso diretto a messages.value invece di t()/te(): molti nomi crop
 * contengono un punto (es. "Festuca (Sp. Festuca Pratensis Huds.)") che
 * t()/te() interpretano come separatore di path annidato, spezzando la
 * chiave e facendo fallire silenziosamente la traduzione.
 */
export function translateCropName(name) {
  if (!name) return name
  const messages = i18n.global.messages.value
  const locale = i18n.global.locale.value
  const direct = messages[locale]?.cropVocab?.[name]
  if (direct !== undefined) return direct
  const fallback = messages.it?.cropVocab?.[name]
  return fallback !== undefined ? fallback : name
}
